import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const CouponScroll: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            CouponScroll
        </div>
    )
}

export const CouponScrollSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        CouponScroll
    </div>
}

export default CouponScroll